// @flow
import React from 'react';

type Props = {
  className?: string,
  size?: string,
  name?: string,
  onClick: () => void
}

/* eslint-disable */
const Icon = ({ className, size, name, onClick }: Props) => (
  <i 
    role={onClick ? 'button' : ''}
    className={
      'icon '
      + `${className || ''} `
      + `is-${size || 'small'} `
      + `ic-${name || ''} `
    }
    onClick={onClick}
    aria-label={name}
    onKeyPress={onClick} />
)
/* eslint-enable */
export default Icon;



// WEBPACK FOOTER //
// ./src/components/shared/Icon.js